
import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, InspectorControls, InnerBlocks } from '@wordpress/block-editor';
import { Button, ButtonGroup, PanelBody,  } from  '@wordpress/components'; 
import './editor.scss';


export default function Edit({ attributes, setAttributes } ) {
	const { backgroundColor,  content, title, speed } = attributes;
	const blockProps = useBlockProps();

	const onChangeTitle = ( newTitle ) => {
		setAttributes( { title: newTitle } )
	}

	const speedChange = ( newspeed ) => {
		// Update attributes.
		setAttributes( { speed: newspeed } );
		
	}
	const ALLOWED_BLOCKS = [
		'core/group',
		'core/columns',
		'wp-gb/inner-blocks'
	];

	/* { "backgroundColor":"tertiary", "textColor":"contrast"} */
	const BLOCKS_TEMPLATE = [ [ 'core/group', {}, 
			[
				[ 'core/image'    ,  ],
				[ 'core/paragraph', { "placeholder": 'Image Details'}],
				
			] /* end of core/group */
		] /* core/group */
	 ]; /* template */

	
	return (
		<div { ...blockProps } 
			style={ { backgroundColor: backgroundColor } }
		>
			<InspectorControls>
				<PanelBody title={ __( 'Select Toggle Speed','hide-or-toggle' ) }>
					
				<ButtonGroup aria-label={ __( 'Select speed', 'hide-or-toggle'  ) } >
					{ [ 'slow','fast' ].map( ( speedValue ) => {
						return (
							<Button
							key={ speedValue }
							variant="secondary"
							onClick={ () => speedChange( speedValue ) }
							>
								{ speedValue }
							</Button>
						);
					} ) }
				</ButtonGroup>
				</PanelBody>
				</InspectorControls>
				<RichText 
					tagName='div' 
					className='title'
					value={ title } 
					onChange={onChangeTitle}
					placeholder={__('This is a title placeholder','hide-or-toggle')}
					
					/>
				<div className='hidden'>
					<InnerBlocks
						allowedBlocks={ ALLOWED_BLOCKS }
						template = { BLOCKS_TEMPLATE }
						templateLock={false} 
						/>
			
				</div>
		</div>
	);
}
